import type { NoteKind } from '../../../../api/venue-marketing';

import { NOTE_KIND_CLASSES, NOTE_KIND_LABELS } from './marketing-note-lists';

/** The kind of a note, or "Done" once an action item is finished. */
export function NoteKindPill({ kind, done }: { kind: NoteKind; done: boolean }) {
  return (
    <span
      className={`nb-pill ${done ? '' : NOTE_KIND_CLASSES[kind]}`}
      style={{
        flex: '0 0 auto',
        height: 17,
        fontSize: 9,
        padding: '0 6px',
        fontWeight: 700,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        ...(done
          ? {
              background: 'var(--nb-surface-2)',
              color: 'var(--nb-muted)',
              borderColor: 'transparent',
            }
          : {}),
      }}
    >
      {done ? 'Done' : NOTE_KIND_LABELS[kind]}
    </span>
  );
}
